import React from "react";
import Datalist from "../../../atoms/datalist/datalist";
import ProgressBar from "../../../atoms/progress-bar-mentoria/progressBarMentoria";
import RadioButton from "../../../atoms/radio-button/radioButton";
import Rating from "../../../molecules/rating/rating";
import SliderQuestion from "../../../molecules/slider-question/sliderQuestion";
import searchIcon from '../../../../assets/images/icons/chevron-down.svg'
import "./mentoriaQuestion.scss";
import { IQuestion } from "../interfaces";
import ImageBlobBackground from "../image-blob-background/imageBlobBackground";
import Input from "../../../atoms/input/input";
import RadioLiker from "../../../atoms/radio-liker/radioLiker";

interface mentoriaQuestionProps {
   question: IQuestion;
   value: any;
   setData: any;
   formData: any;
   movePreviousQuestion: any;
   moveNextQuestion: any;
   error?: any;
   isSlider?: boolean;
   sliderValue?: number;
   sliderMaxValue?: number;
   parentId?: number;
   blobImage: string;
}

const MentoriaQuestion = (props: mentoriaQuestionProps) => {
   const { question } = props;

   const handleChange = (e: any) => {
      props.setData(
         e.target.value,
         e.target.name,
         (e.target.type === "checkbox") ? e.target.type : null
      );
   };

   const filterComponent = () => {
      switch (question.type.name) {
         case "select":
            return (
               <div className="m-question__input__select-container" key={question.id}>

                  <select
                     className={`m-question__input__select-container__select`}
                     onChange={handleChange}
                     name={question.id + ""}
                     id={question.id + ""}
                  >
                     <option value="" selected hidden>Selecciona</option>
                     {(question.options || []).map((option) => (
                        <option
                           key={option.name}
                           value={JSON.stringify(option)}
                           selected={option.id === props.value?.id}
                        >
                           {option.name}
                        </option>
                     ))}
                  </select>
                  <img
                     src={searchIcon}
                     alt="Dropdown menu"
                     className='m-question__input__select-container__arrow'
                  />
                  {/* {error && <span className='a-input__error'>{error}</span>} */}
               </div>
            );
         case "text":
         case "email":
            return (
               <input
                  className="m-question__input__regular"
                  value={props.value}
                  onChange={handleChange}
                  name={question.id + ""}
                  placeholder="Escribe tu respuesta"
                  type={question.type.name}
                  required={question.required}
                  key={question.id}
               ></input>
            );
         case "number":
            return (
               <input
                  className="m-question__input__regular"
                  value={props.value}
                  onChange={handleChange}
                  name={question.id + ""}
                  placeholder="Escribe tu respuesta"
                  type="number"
                  pattern="[0-9]+"
                  required={question.required}
                  key={question.id}
               ></input>
               /* Tipo date del .com
                  <Input
                  title=""
                  value=""
                  nameId=""
                  type="date"
                  handleChange={() => { }}
               />
               */
            );
         case "radio":
            return (
               <div className={`m-question__input__radio ${question.horizontal ? '--horizontal' : ''}`}>
                  {question.options &&
                     question.options.map((option) => (
                        // <div key={option.name} className={`m-question__input__radio ${props.value === option ? "--input-selected" : ""}`}>
                        <RadioButton
                           id={question.id + ""}
                           value={option}
                           name={question.id + ""}
                           isChecked={props.value?.id === option.id}
                           label={option.name}
                           onChange={handleChange}
                           key={option.id}
                        />
                        // </div>
                     ))}
               </div>
            );
         case "checkbox":
            return (
               <div className="m-question__input__checkbox-container" onChange={handleChange}>
                  {question.options &&
                     question.options.map((option) => (
                        <div
                           key={option.name}
                           className={`m-question__input__checkbox-container__checkbox ${props.value?.includes(option) ? "--input-selected" : ""}`}>
                           <input
                              type="checkbox"
                              id={option.name}
                              value={JSON.stringify(option)}
                              name={question.id + ""}
                              defaultChecked={props.value?.find((el) => el.id === option.id)}

                           ></input>
                           <label
                              htmlFor={option.name}
                              className="m-question__input__checkbox-container__checkbox__title"
                           >
                              {option.name}
                           </label>
                        </div>
                     ))}
               </div>
            );

         case "liker":
            return (
               <div className={`m-question__input__radioLiker ${question.horizontal ? '--horizontal' : ''}`}>
                  {question.options &&
                     question.options.map((option, index) => (
                        // <div key={option.name} className={`m-question__input__radio ${props.value === option ? "--input-selected" : ""}`}>
                        <RadioLiker
                           id={question.id + ""}
                           value={option}
                           name={question.id + ""}
                           isChecked={props.value?.id === option.id}
                           label={option.name}
                           onChange={handleChange}
                           key={option.id}
                           pos={index + 1}
                        />
                        // </div>
                     ))}
               </div>
            );

         // case "liker":
         //    return (
         //       <Rating
         //          value={props.value}
         //          onChange={props.setData}
         //          size={5}
         //          name={question.id + ""}
         //       />
         //    );
         case "datalist":
            return (
               <Datalist
                  name={question.id + ""}
                  id={question.id + ""}
                  options={question.options || []}
                  onChange={props.setData}
                  value={props.value}
               />
            )
         case "title":
            return (
               <div className="m-question__title-container">
                  <ImageBlobBackground blobImage={props.blobImage} image={question.help} />
                  <h2 className="m-question__title-container__title">{question.name}</h2>
                  {
                     question.options.map((option) => (
                        <p key={option.id} className="m-question__title-container__text">
                           {option.name}
                        </p>
                     ))
                  }
               </div>
            )

         case "date":
            return (
               <input
                  className="m-question__input__regular"
                  value={props.value || ""}
                  onChange={handleChange}
                  name={question.id + ""}
                  type={question.type.name}
                  required={question.required}
                  key={question.id}
               ></input>
            );

         case "slider radio":
            return (
               <SliderQuestion
                  parentId={props.parentId || 0}
                  setData={props.setData}
                  formData={props.formData}
                  questions={question.childQuestions || []}
                  key={props.parentId}
               />
            )
         case "slider likert":
            return (
               <SliderQuestion
                  parentId={props.parentId || 0}
                  setData={props.setData}
                  formData={props.formData}
                  questions={question.childQuestions || []}
                  key={props.parentId}
               />
            )
         default:
            return (
               <input
                  className="m-question__input__regular"
                  value={props.value || ""}
                  onChange={handleChange}
                  name={question.id + ""}
                  placeholder="Escribe tu respuesta"
                  type={'text'}
                  key={question.id}
               ></input>);
      }
   };

   return (
      <div className="m-question">
         <div
            className={`m-question__header ${props.isSlider ? "m-question__header--slider" : ""
               }`}
         >
            {question.type.name !== "title" && (
               <h2
                  className={`m-question__header__title ${props.isSlider ? "m-question__header__title--slider" : ""
                     }`}
               >
                  {question.name}
               </h2>
            )}
            {question.type.id === 11 && (
               <>
                  <br />
                  <h4 className="m-question__header__help">{question.help}</h4>
               </>
            )}
         </div>
         {props.isSlider && (
            <div className="m-question__progress">
               <ProgressBar
                  percentage={props.sliderValue || 0}
                  onClick={() => { }}
                  simple
               />
            </div>
         )}
         <div
            className={`m-question__input ${question.horizontal ? "--horizontal" : ""
               }`}
         >
            {filterComponent()}
         </div>
      </div>
   );
};

export default MentoriaQuestion;
